import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Box, Divider, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import GroupIcon from "@material-ui/icons/Group";
import { useQuery } from "@apollo/client";
import { GET_CITIZEN_MENU } from "../../../../../quries/citizenJoy";
import MoCitizenJoyMenu from "./MoCitizenJoyMenu";
import MoLaborIssueMenu from "./MoLaborIssueMenu";

const useStyles = makeStyles((theme) =>
  createStyles({
    topContainer: {
      paddingLeft: 16,
      paddingBottom: 8,
    },
    iconDiv: {
      //   paddingRight: 16,
    },
    textDiv: {
      fontSize: 16,
    },
    aspectRatioBox: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      borderRadius: 12,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      textAlign: "center",
      fontSize: 20,
      color: "white",
      background: "no-repeat center center",
      backgroundImage: "url(/images/history/3.png)",
      backgroundSize: "100%",
    },

    topCategory: {
      //   paddingRight: 8,
      fontSize: 16,
      fontFamily: "Noto Sans KR",
      fontWeight: 700,
      paddingBottom: 8,
    },
  })
);

interface MoActiveMenu {
  setOpen: any;
  setExpanded: any;
}
function MoActiveMenu({ setOpen, setExpanded }: MoActiveMenu) {
  const classes = useStyles();
  const [feat_img, setFeatImg] = useState<any>(null);
  const [citizenJoyArr, setCitizenJoyArr] = useState<any>(null);
  const [citizenActualJoyArr, setActualCitizenJoyArr] = useState<any>([]);
  const [title, setTitle] = useState<any>(null);
  const [parentId, setParentId] = useState<any>(null);
  const [subMenu, setSubMenu] = useState<any>(null);


  return (
    <Grid xs={12} item>
      <Divider />
      <MoCitizenJoyMenu setOpen={setOpen} setExpanded={setExpanded} />
      <Divider />
      <MoLaborIssueMenu setOpen={setOpen} setExpanded={setExpanded} />
    </Grid>
  );
}

export default MoActiveMenu;
